var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{attrs:{"feed-asset-area":""}},[(_vm.value.img)?_c('ImageAsset',{attrs:{"url":_vm.value.img}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }